import { DirectiveOptions, DirectiveBinding } from 'vue/types/options';

type CustomElement = HTMLElement & {
  __vueClickOutside__: { handler: Function; callback: Function };
};

function validate(binding: DirectiveBinding) {
  if (typeof binding.value !== 'function') {
    console.warn(
      '[Vue-click-outside:] provided expression',
      binding.expression,
      'is not a function.'
    );
    return false;
  }

  return true;
}

export const directive: DirectiveOptions = {
  bind(el, binding, vNode) {
    const customElement = el as CustomElement;
    if (!validate(binding)) return;

    function handler(e: TouchEvent | MouseEvent) {
      if (!vNode.context) return;

      const elements = e.composedPath && e.composedPath();
      elements && elements.length > 0 && e.target && elements.unshift(e.target);

      if (e.target && el.contains(e.target as Node)) return;

      customElement.__vueClickOutside__.callback(e);
    }

    customElement.__vueClickOutside__ = {
      handler: handler,
      callback: binding.value
    };
    const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'mousedown';
    document.addEventListener(clickHandler, handler);
  },

  update(el, binding) {
    const customElement = el as CustomElement;
    if (validate(binding)) customElement.__vueClickOutside__.callback = binding.value;
  },

  unbind(el) {
    // Remove Event Listeners
    const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'mousedown';
    const customElement = el as HTMLElement & {
      __vueClickOutside__?: Object & { handler: () => {} };
    };
    customElement.__vueClickOutside__ &&
      document.removeEventListener(clickHandler, customElement.__vueClickOutside__.handler);
    delete customElement.__vueClickOutside__;
  }
};
